module.exports = __webpack_public_path__ + "static/assets/64f4c56120814dd5432fcd3b92938921.svg";